import Vue from "vue";
import Router from "vue-router";
import VueAlertify from "vue-alertify";
import Intro from "@/components/Intro";
import AddAssets from "@/components/AddAssets";
import ViewAssets from "@/components/ViewAssets";

Vue.use(Router);
Vue.use(VueAlertify);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Intro",
      component: Intro
    },
    {
      path: "/add",
      name: "AddAssets",
      component: AddAssets
    },
    {
      path: "/view/:user_id",
      name: "ViewAssets",
      component: ViewAssets
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js